var React = require('react');

function AddIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 2a18 18 0 1018 18A18 18 0 0020 2zm7.425 23.303l-2.122 2.122L20 22.12l-5.303 5.304-2.122-2.122L17.88 20l-5.304-5.303 2.122-2.122L20 17.88l5.303-5.304 2.122 2.122L22.12 20z","fill":"#047bf8"}));
}

AddIcon.defaultProps = {"viewBox":"0 0 40 40","className":"icon color--primary"};

module.exports = AddIcon;

AddIcon.default = AddIcon;
